<template>
<v-expansion-panel>
    <v-expansion-panel-header>{{$t('massblatt')}}</v-expansion-panel-header>
    <v-expansion-panel-content>
        <template v-for="(item, index) in currentDoorConfiguration">
            <v-row :key="index">
                <v-col cols="8" class="py-1">
                    <div class="caption">{{ item.description }}</div>
                </v-col>
                <v-col cols="4" class="py-1">
                    <div class="caption success--text">-{{ item.value.value }} {{ item.code }}</div>
                </v-col>
            </v-row>
        </template>
    </v-expansion-panel-content>
</v-expansion-panel>
    <!-- <div class="card-body">
        <div v-for="(characteristic, index) in currentDoorConfiguration" :key="index" class="card-element">
            <h3>{{ characteristic.description }}  ({{ characteristic.code }})</h3>
            <span>{{ characteristic.value.description }} {{ characteristic.value.description != '' ? ' - ' : ' '}} {{ characteristic.value.value }}</span>
        </div>        
    </div> -->
</template>
<script>
    import Vue from 'vue';
    import * as $ from 'jquery';
    import { mapGetters } from 'vuex';
    import { DoorConfiguration } from '../../../configurator/DoorConfiguration';

    export default Vue.extend({
        name: 'RMeasures',
        computed: {
        ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration']),
            currentDoorConfiguration() {
                return this.getCurrentDoorConfiguration.Get(DoorConfiguration.Measure);
            }
        },
        methods: {
            
        },
        mounted() {
            
        }
    })
</script>
<style scoped>

</style>